/* eslint-disable @typescript-eslint/naming-convention */
import { asMessages } from '../../Utils/Intl/AsMessages';

const vehicleScope = 'containers.vehicle';
const vehicleDetailsScope = `${vehicleScope}.details`;
const vehicleSpecScope = `${vehicleScope}.spec`;
const pluarliseCarsScope = `${vehicleScope}.pluraliseCars`;
const unitsScope = `${vehicleSpecScope}.units`;

const gearBoxScope = `${vehicleSpecScope}.mappings.gearBox`;

const fuelTypeScope = `${vehicleSpecScope}.mappings.fuelType`;

const bodyTypeScope = `${vehicleSpecScope}.mappings.bodyType`;

const colorScope = `${vehicleSpecScope}.mappings.color`;
const colorsScope = `${vehicleSpecScope}.mappings.colors`;
const interiorTypeScope = `${vehicleSpecScope}.mappings.interiorType`;
const damagedStateScope = `${vehicleDetailsScope}.mappings.damagedState`;

const vehicleDetailsMessagesScope = {
  mileage: 'miles',
  owners: 'owner(s)',
} as const;

const vehiclesSpecMessagesScope = {
  seats: 'seats',
  doors: 'doors',
  horsepower: 'bhp',
  notReported: 'Not reported',
} as const;

const unitsMessagesScope = {
  seat: 'seater',
  door: 'door',
  litre: 'litre',
  litres: 'litres',
} as const;

const pluarliseCarsMessagesScope = {
  car: 'car',
  cars: 'cars',
} as const;

const gearBoxMessagesScope = {
  automatic: 'Automatic',
  manual: 'Manual',
  semiauto: 'Semi-automatic',
  automatic_gear: 'Automatic',
  manual_gear: 'Manual',
  semiautomatic_gear: 'Semi-automatic',
  none: 'Other',
  unknown: 'Other',
};

export const fuelTypeMessagesScope = {
  petrol: 'Petrol',
  diesel: 'Diesel',
  hybrid: 'Hybrid',
  hybrid_diesel: 'Hybrid - Diesel',
  hybrid_petrol: 'Hybrid - Benzin',
  electric: 'Electric',
  lpg: 'LPG',
  gas: 'Gas',
  ethanol: 'Ethanol',
  other: 'Autres',
};

export const colorMessageScope = {
  beige: 'Beige',
  black: 'Black',
  blue: 'Blue',
  brown: 'Brown',
  gold: 'Gold',
  green: 'Green',
  grey: 'Grey',
  orange: 'Orange',
  other: 'Others',
  othercolor: 'Other colors',
  purple: 'Purple',
  red: 'Red',
  silver: 'Silver',
  white: 'White',
  yellow: 'Yellow',
};

const colorsMessageScope = {
  'beige.one': 'Beige',
  'beige.other': 'Beige',
  'black.one': 'Black',
  'black.other': 'Black',
  'blue.one': 'Blue',
  'blue.other': 'Blue',
  'brown.one': 'Brown',
  'brown.other': 'Brown',
  'green.one': 'Green',
  'green.other': 'Green',
  'grey.one': 'Grey',
  'grey.other': 'Grey',
  'gold.one': 'Gold',
  'gold.other': 'Gold',
  'purple.one': 'Purple',
  'purple.other': 'Purple',
  'orange.one': 'Orange',
  'orange.other': 'Orange',
  'other.one': 'Others',
  'other.other': 'Others',
  'othercolor.one': 'Other colors',
  'othercolor.other': 'Other colors',
  'red.one': 'Red',
  'red.other': 'Red',
  'silver.one': 'Silver',
  'silver.other': 'Silver',
  'white.one': 'White',
  'white.other': 'White',
  'yellow.one': 'Yellow',
  'yellow.other': 'Yellow',
};

export const bodyTypeMessagesScope = {
  bus: 'Bus',
  compact: 'Compact',
  convertible: 'Convertible',
  coupe: 'coupe',
  estate: 'Estate',
  family: 'Estate',
  hatchback: 'Hatchback',
  industrial: 'VU/VI',
  mpv: 'MPV',
  othercar: 'Other',
  pickup: 'Pick-up',
  saloon: 'Saloon',
  sedan: 'Saloon',
  sport_tourer: 'Sport Tourer',
  suv: 'SUV',
  van: 'Van',
  sportscar: 'Sportwagen',
  transporter: 'Transporter / Nutzfahrzeug',
  motorhome: 'Wohnmobil oder wagen',
  smallcar: 'Kleinwagen',
};

export const interiorTypeMessagesScope = {
  fabric: 'Stoff',
  leather: 'Leder',
  partial_leather: 'Teilleder',
  velour: 'Velour',
  alcantara: 'Alcantara',
  other: 'Andere',
};

export const damagedStateMessagesScope = {
  NO_DAMAGE: 'Unfallfrei',
  DAMAGE_REPAIRED: 'Schaden behoben',
  MINOR_TECHNICAL_DEFECTS: 'Beschädigt',
  ACCIDENT_DAMAGED: 'Unfallschaden',
  MISSING_INFORMATION: 'Keine Angabe',
};

const vehicleDetailsDefinition = asMessages(vehicleDetailsScope, vehicleDetailsMessagesScope);
const vehicleSpecDefinition = asMessages(vehicleSpecScope, vehiclesSpecMessagesScope);
export const unitsDefinition = asMessages(unitsScope, unitsMessagesScope);
export const pluarliseCarsDefinition = asMessages(pluarliseCarsScope, pluarliseCarsMessagesScope);
export const vehicleSpecGearBoxDefinition = asMessages(gearBoxScope, gearBoxMessagesScope);
export const vehicleSpecFuelTypeDefinition = asMessages(fuelTypeScope, fuelTypeMessagesScope);
export const vehicleSpecBodyTypeDefinition = asMessages(bodyTypeScope, bodyTypeMessagesScope);
export const vehicleSpecInteriorTypeDefinition = asMessages(
  interiorTypeScope,
  interiorTypeMessagesScope,
);
export const vehicleDetailsDamagedStateDefinition = asMessages(
  damagedStateScope,
  damagedStateMessagesScope,
);
/**
 * @deprecated use `vehicleSpecColorsDefinition` in this file instead.
 * `vehicleSpecColorsDefinition` supports pluralization, this deprecated definition does not.
 */
export const vehicleSpecColorDefinition = asMessages(colorScope, colorMessageScope);
export const vehicleSpecColorsDefinition = asMessages(colorsScope, colorsMessageScope);

export const VehicleMessages = {
  ...vehicleDetailsDefinition.messages,
  ...vehicleSpecDefinition.messages,
  ...vehicleSpecGearBoxDefinition.messages,
  ...vehicleSpecFuelTypeDefinition.messages,
  ...vehicleSpecBodyTypeDefinition.messages,
  ...vehicleSpecColorDefinition.messages,
  ...vehicleSpecColorsDefinition.messages,
  ...vehicleSpecInteriorTypeDefinition.messages,
  ...vehicleDetailsDamagedStateDefinition.messages,
};

export const VehicleDefaultMessages = {
  ...vehicleDetailsDefinition.defaultMessages,
  ...vehicleSpecDefinition.defaultMessages,
  ...vehicleSpecGearBoxDefinition.defaultMessages,
  ...vehicleSpecFuelTypeDefinition.defaultMessages,
  ...vehicleSpecBodyTypeDefinition.defaultMessages,
  ...vehicleSpecColorDefinition.messages,
};
